import { createContext, use } from 'react'

export const UserMenuContext = createContext<{ closeMenu: () => void }>({ closeMenu: () => {} })

export const useUserMenuContext = () => use(UserMenuContext)
